import {
  getStudentList,
  getStudentAssignmentList,
  getStudentById,
  getStudentListByClassId,
  deleteStudentClass,
  changeCenter,
  changeCenterPeriod,
  updateStudent,
  resetStudentRegistration,
  resetStudentPassword,
  //Değerlendirme Aşaması öğrencileri
  getEvaluateCertificateStudentList,
  getPaymentList,
  finderStudentFiltered,
  loadStudentScores,
} from "@/services/student.service";

import {
  getClassById,
} from "@/services/class.service";

import {  formatDateEditZone } from "@/utils/utils";
import { setPaginationDetails } from "../../utils/utils";

// initial state
const state = () => ({
  studentModel: {
    classId: null,
  },

  findStudentModel: {
    classId: null,
  },

  newStudentModel: {
    // FirstName: "Manuel Ad 3",
    // LastName: "Manuel Soyad 3",
    // GenderId: 1,
    // DateOfBirth: "1998-01-01",
    // NationalitysId: 150,
    // phoneCode: 225,
    // Tel: "505982564848",
    // Email: "yeeogrenci@hotmail.com",
    // Adress: "Adress Satır",
    // countryId: 225,
    // citiesId: 107139,
    // LevelsId: 1,
    // EducationTypeId: 2,
    // PaidId: 2,
    // ClassId: null,
    // File: null,
    photo: "",
  },

  studentInfoModel: {},

  studentList: [],
  findStudentsList: [],
  studentScoreList: [],
  selectedStudents: [],

  studentAssignModel: {},
});

// mutations
const mutations = {
  setStudentModel(state, data) {
    state.studentModel = data;
  },

  setNewStudentModel(state, data) {
    state.newStudentModel = data;
  },

  setStudentInfoModel(state, data) {
    state.studentInfoModel = data;
  },

  setStudentList(state, data) {
    state.studentList = data;
  },

  setFindStudentModel(state, data) {
    state.findStudentModel = data;
  },
  
  findStudentList(state, data) {
    state.findStudentsList = data;
  },
  
  setStudentScores(state, data) {
    state.studentScoreList = data;
  },
   
  setSelectedStudents(state, data) {
    state.selectedStudents = data;
  },

  setStudentAssignModel(state, data) {
    state.studentAssignModel = data;
  },
};

// actions
const actions = {
  async loadEvaluateCertificateStudentList(vuexContext, co) {
    return await getEvaluateCertificateStudentList(co).then(async (response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        item.fullname = item.firstName + " " + item.lastName;
        item.studentClassStatus = `${item.classStatusMulti?.classStatus?.startTime} - ${item.classStatusMulti?.classStatus?.endTime} / ${item.classStatusMulti?.classStatus?.levels?.description}`;
        item.uniqueId = item.id + "" + item.classStatusMultiId;
      });
      return data;
    });
  },

  //Öğrenci Listesi
  async loadStudentList(vuexContext, co) { 
    return await getStudentList(co).then(async (response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      items.map((item, index) => {
        if (index === 0) item.active = true;
        else item.active = false;
        item.index = index + 1;

        item.studentClassName = item.userStudentClassList?.find((s) => s.active && s.class?.active)?.class?.name;

        if (item.lastClassStatus) {
          item.lastStatus = item.lastClassStatus.levelsDto?.description + " / " + item.lastClassStatus.classStatusDto?.startTime + " - " + item.lastClassStatus.classStatusDto?.endTime;
        }

        if (item.userStudentDto) {
          item.userStudentDto.name = item.userStudentDto?.firstName;
          item.fullName = item.userStudentDto ? `${item.userStudentDto.firstName} ${item.userStudentDto.lastName}` : "";
          item.userStudentId = item.userStudentDto ? item.userStudentDto.id : undefined;
          item.email = item.userStudentDto.email;
        }
        item.disabled = item.studentSelectionDto?.id === 1 ? true : false;

        /**** */
        item.classDayAndTime = "";
        item.dayAndTime = "";
        if (item.classDayAndTimeList && item.classDayAndTimeList.length < 1) {
          item.classDayAndTime = "Veri girişi yapılmadı.";
          item.dayAndTime = "Veri girişi yapılmadı.";
        }

        item.classDayAndTimeList?.forEach((dayTime, index) => {
          //TSİ
          item.classDayAndTime += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, dayTime.classTemp.timePeriod, "+03:00")} - ${formatDateEditZone(
            dayTime.endDate,
            dayTime.classTemp.timePeriod,
            "+03:00"
          )}
          `;
          if (index < item.classDayAndTimeList.length - 1) {
            item.classDayAndTime += " / ";
          }

          //Normal
          item.dayAndTime += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, "+03:00", "+03:00")} -  ${formatDateEditZone(dayTime.endDate, "+03:00", "+03:00")}
          `;
          if (index < item.classDayAndTimeList.length - 1) {
            item.dayAndTime += " / ";
          }
        });

        item.newName = item.name + " / " + item.timePeriod;
        /**** */
      });

      setPaginationDetails(co, totalCount, totalPages);

      vuexContext.commit("setStudentList", items);
      return items;
    });
  },

  async findStudentFiltered(vuexContext, co) {
    return await finderStudentFiltered(co).then(async (response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      items.map((item, index) => {
        if (index === 0) item.active = true;
        else item.active = false;
        item.index = index + 1;

        item.studentClassName = item.userStudentClassList?.find((s) => s.active && s.class?.active)?.class?.name;

        if (item.lastClassStatus) {
          item.lastStatus = item.lastClassStatus.levelsDto?.description + " / " + item.lastClassStatus.classStatusDto?.startTime + " - " + item.lastClassStatus.classStatusDto?.endTime;
        }

        if (item.userStudentDto) {
          item.userStudentDto.name = item.userStudentDto?.firstName;
          item.fullName = item.userStudentDto ? `${item.userStudentDto.firstName} ${item.userStudentDto.lastName}` : "";
          item.userStudentId = item.userStudentDto ? item.userStudentDto.id : undefined;
          item.email = item.userStudentDto.email;
        }
        item.disabled = item.studentSelectionDto?.id === 1 ? true : false;

        /**** */
        item.classDayAndTime = "";
        item.dayAndTime = "";
        if (item.classDayAndTimeList && item.classDayAndTimeList.length < 1) {
          item.classDayAndTime = "Veri girişi yapılmadı.";
          item.dayAndTime = "Veri girişi yapılmadı.";
        }

        item.classDayAndTimeList?.forEach((dayTime, index) => {
          //TSİ
          item.classDayAndTime += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, dayTime.classTemp.timePeriod, "+03:00")} - ${formatDateEditZone(
            dayTime.endDate,
            dayTime.classTemp.timePeriod,
            "+03:00"
          )}
          `;
          if (index < item.classDayAndTimeList.length - 1) {
            item.classDayAndTime += " / ";
          }

          //Normal
          item.dayAndTime += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, "+03:00", "+03:00")} -  ${formatDateEditZone(dayTime.endDate, "+03:00", "+03:00")}
          `;
          if (index < item.classDayAndTimeList.length - 1) {
            item.dayAndTime += " / ";
          }
        });

        item.newName = item.name + " / " + item.timePeriod;
        /**** */
      });

      setPaginationDetails(co, totalCount, totalPages);

      vuexContext.commit("findStudentList", items);
      return items;
    });
  },

  async loadStudentScore(vuexContext, co) {
    return await loadStudentScores(co).then(async (response) => {
      let items = response.data.data;
      items.map((item, index) => {
        (index === 0)
        item.index = index + 1;
        if(item.changedTime.includes("0001"))
        {
          item.changedTime = "";
        }
      });
      vuexContext.commit("setStudentScores", items);
      return items;
    });
  },

  async loadClassById(vuexContext, classId) {
    return await getClassById(classId).then((response) => {
      let data = response.data.data;
      //console.log("mm",data);
      data.map((item,index)=>{
        item.index = index+1;
       });
      vuexContext.commit("setStudentList", data);
      return data;
    });
  },

  //ödeme listesi
  async loadStudentPaymentList(vuexContext, co) {
    return await getPaymentList(co).then(async (response) => {
      let data = response.data.data;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      let items = data.items;

      items.map((item, index) => {
        item.index = index + 1;
        item.totalPrice = item.amount + " " + item.currencyCode;
        // item.studentClassName = item.userStudentClassList?.find((s) => s.active && s.class?.active)?.class?.name;
        if (item.lastClassStatus) {
          item.lastStatus = item.lastClassStatus.levelsDto?.description + " / " + item.lastClassStatus.classStatusDto?.startTime + " - " + item.lastClassStatus.classStatusDto?.endTime;
        }
        if (item.userStudentDto) {
          item.userStudentDto.name = item.userStudentDto?.firstName;
          item.fullName = item.userStudentDto ? `${item.userStudentDto.firstName} ${item.userStudentDto.lastName}` : "";
          //item.userStudentId = item.userStudentDto ? item.userStudentDto.id : undefined;
          item.email = item.userStudentDto.email;
        }
      });

      setPaginationDetails(co, totalCount, totalPages);

      vuexContext.commit("setStudentList", items);
      return items;
    });
  },

  async loadStudentAssigmentList(vuexContext, co) {
    return await getStudentAssignmentList(co).then(async (response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        if (item.userStudentDto) {
          item.userStudentDto.name = item.userStudentDto?.firstName;
          item.fullName = item.userStudentDto ? `${item.userStudentDto.firstName} ${item.userStudentDto.lastName}` : "";
          item.userStudentId = item.userStudentDto ? item.userStudentDto.id : undefined;
          item.email = item.userStudentDto.email;
        }
      });
      return data;
    });
  },

  async loadStudentById(vuexContext, studentId) {
    return await getStudentById(studentId).then((response) => {
      let data = response.data.data;
      
      data.fullName = `${data.firstName || data.FirstName || ''} ${data.lastName || data.LastName || ''}`.trim();
      data.email = data.eposta || data.Eposta || data.email || data.Email;
      
      return data;
    });
  },

  async loadStudentListByClassId(vuexContext, classId) {
    return await getStudentListByClassId(classId).then(async (response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        item.fullName = item.firstName + " " + item.lastName;
      });
      return data;
    });
  },

  async deleteStudentClass(vuexContext, obj) {
    return await deleteStudentClass(obj).then(async (response) => {
      let data = response.data.data;
      return data;
    });
  },

  async updateStudent(vuexContext, data) {
    return await updateStudent(data).then(async (response) => {
      let datas = response;
      return datas;
    });
  },

  async resetStudentRegistration(vuexContext, data) {
    return await resetStudentRegistration(data).then(async (response) => {
      return response.data;
    });
  },

  async resetStudentPassword(vuexContext, data) {
    return await resetStudentPassword(data).then(async (response) => {
      return response.data;
    });
  },

  async changeCenter(vuexContext, data) {
    return await changeCenter(data).then(async (response) => {
      let data = response.data.data;
      return data;
    });
  },

  async changeCenterPeriod(vuexContext, data) {
    return await changeCenterPeriod(data).then(async (response) => {
      let data = response.data.data;
      return data;
    });
  },

  addStudentList(vuexContext, data) {
    vuexContext.commit("setStudentList", data);
  },

  addStudentModel(vuexContext, data) {
    vuexContext.commit("setStudentModel", data);
  },

  addNewStudentModel(vuexContext, data) {
    vuexContext.commit("setNewStudentModel", data);
  },

  addStudentInfoModel(vuexContext, data) {
    vuexContext.commit("setStudentInfoModel", data);
  },

  addSelectedStudents(vuexContext, data) {
    vuexContext.commit("setSelectedStudents", data);
  },

  addStudentAssignModel(vuexContext, data) {
    vuexContext.commit("setStudentAssignModel", data);
  },

  addFindStudentModel(vuexContext, data) {
    vuexContext.commit("setStudentModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
